module.exports = __webpack_public_path__ + "img/wp-new-habit-card5.e1c9a327.jpg";